import React from 'react';
import PropTypes from 'prop-types';
import { Circle, Polygon } from '@react-google-maps/api';
import { circleOptions, polygonOptions } from '../../app/google_maps';

const Drawing = ({ position, radius, polygon, region }) => {
  switch (region) {
    case 'circle':
      if (!radius) { return null; }
      return (
        <Circle
          center={position}
          radius={radius}
          options={circleOptions}
        />
      );
    case 'polygon':
      if (!polygon) { return null; }
      return (
        <Polygon
          paths={polygon}
          options={polygonOptions}
        />
      );
    default:
      return null;
  }
};

Drawing.defaultProps = {
  radius: null,
  polygon: null,
};

Drawing.propTypes = {
  position: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }).isRequired,
  radius: PropTypes.number,
  polygon: PropTypes.arrayOf(PropTypes.shape()),
  region: PropTypes.oneOf(['circle', 'polygon']).isRequired,
};

export default Drawing;
